/**
 * Created by fijas on 5/29/17.
 */
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

import {Query} from '../../query/Query';

import {Observable} from 'rxjs';
import {QueryForm} from '../../query/query-view/QueryForm';
import { HttpClient, HttpParams } from '@angular/common/http';
import {QueryIssueList} from '../../query/QueryIssueList';
import {SearchForm} from '../../query/query-listing/SearchForm';
import {Contact} from '../../contacts/Contact';
import {StandardResponse} from '../../common/models/StandardResponse';

@Injectable()
export class QueryService {
    private queryUrl: string;  // URL to web api
    private projectUrl: string;  // URL to web api

    constructor(private http: HttpClient) {
        this.queryUrl = environment.apiBaseUrl + 'queries';
        this.projectUrl = environment.apiBaseUrl + 'projects';
    }

    getQuery(id: number): Observable<Query> {
        return this.http.get<Query>(this.queryUrl + '/' + id + '?expand=queryThreads,issues');
    }

    getQueries(page: string, searchModel: SearchForm) {
        let params = new HttpParams()
            .set('page', page);
        if(searchModel.status) {
            searchModel.filtered = true;
            params = params.set('status', searchModel.status);
        }
        if(searchModel.term) {
            searchModel.filtered = true;
            params = params.set('term', searchModel.term);
        }
        return this.http.get(this.queryUrl, {params: params, observe: 'response'});
    }

    submitQuery(queryForm: QueryForm): Observable<Query> {
        return this.http.post<Query>(this.queryUrl, queryForm);
    }

    closeQuery(queryId: number): Observable<Query> {
        return this.http.post<Query>(this.queryUrl + '/' + queryId + '/close', {});
    }

    submitReply(queryForm: QueryForm) {
        return this.http.post(this.queryUrl + '/' + queryForm.query_id + '/reply', queryForm);

    }

    getQueryIssueList(): Observable<QueryIssueList[]> {
        return this.http.get<QueryIssueList[]>(this.queryUrl + '/issue');
    }

    checkQueryLimit(): Observable<StandardResponse> {
        return this.http.get<StandardResponse>(this.queryUrl + '/check-limit');
    }
}
